const statechildren = [
  {
    name: "Kuala Lumpur",
    value: "Kuala Lumpur",
    coord: "3.166665872,101.6999833",
    slug: "kualalumpur",
    children: [
      {
        name: "Kuala Lumpur, Malaysia",
        value: "Kuala Lumpur, Malaysia",
        coord: "3.166665872,101.6999833",
        slug: "kualalumpur-kualalumpur"
      }
    ]
  },
  {
    name: "Selangor",
    value: "Selangor",
    coord: "3.0738,101.5183",
    slug: "selangor",
    children: [
      { name: "Banting, Selangor", value: "Banting, Selangor", coord: "2.8136,101.5025", slug: "selangor-banting" },
      { name: "Dengkil, Selangor", value: "Dengkil, Selangor", coord: "2.8594,101.6894", slug: "selangor-dengkil" },
      {
        name: "Kajang, Selangor",
        value: "Kajang, Selangor",
        coord: "2.9936,101.7892",
        slug: "selangor-kajang"
      },
      {
        name: "Klang, Selangor",
        value: "Klang, Selangor",
        coord: "3.0449,101.4455",
        slug: "selangor-klang"
      },
      { name: "Kuala Selangor, Selangor", value: "Kuala Selangor, Selangor", coord: "3.3302,101.2510", slug: "selangor-kualaselangor" },
      {
        name: "Petaling Jaya, Selangor",
        value: "Petaling Jaya, Selangor",
        coord: "3.1073,101.6067",
        slug: "selangor-petalingjaya"
      },
      {
        name: "Port Klang, Selangor",
        value: "Port Klang, Selangor",
        coord: "3.0011,101.3964",
        slug: "selangor-portklang"
      },
      { name: "Rawang, Selangor", value: "Rawang, Selangor", coord: "3.3213,101.5767", slug: "selangor-rawang" },
      { name: "Sabak Bernam, Selangor", value: "Sabak Bernam, Selangor", coord: "3.8059,100.9901", slug: "selangor-sabakbernam" },
      { name: "Sekinchan, Selangor", value: "Sekinchan, Selangor", coord: "3.4990,101.1034", slug: "selangor-sekinchan" },
      {
        name: "Shah Alam, Selangor",
        value: "Shah Alam, Selangor",
        coord: "3.0738,101.5183",
        slug: "selangor-shahalam"
      },
      { name: "Subang Jaya, Selangor", value: "Subang Jaya, Selangor", coord: "3.0564,101.5856", slug: "selangor-subangjaya" },
      { name: "Sungai Besar, Selangor", value: "Sungai Besar, Selangor", coord: "3.6739,101.0074", slug: "selangor-sungaibesar" },
      { name: "Tanjong Karang, Selangor", value: "Tanjong Karang, Selangor", coord: "3.4252,101.1843", slug: "selangor-tanjongkarang" }
    ]
  },
  {
    name: "Putrajaya",
    value: "Putrajaya",
    coord: "2.9264,101.6964",
    slug: "putrajaya",
    children: [
      {
        name: "Putrajaya, Malaysia",
        value: "Putrajaya, Malaysia",
        coord: "2.9264,101.6964",
        slug: "putrajaya-putrajaya"
      }
    ]
  },
  {
    name: "Johor",
    value: "Johor",
    coord: "1.9128,103.1607",
    slug: "johor",
    children: [
      {
        name: "Ayer Hitam, Johor",
        value: "Ayer Hitam, Johor",
        coord: "1.9316,103.1857",
        slug: "johor-ayerhitam"
      },
      {
        name: "Bandar Penawar, Johor",
        value: "Bandar Penawar, Johor",
        coord: "1.5511,104.2518",
        slug: "johor-bandarpenawar"
      },
      {
        name: "Batu Pahat, Johor",
        value: "Batu Pahat, Johor",
        coord: "1.8540,102.9325",
        slug: "johor-batupahat"
      },
      { name: "Gemas Baru, Johor", value: "Gemas Baru, Johor", coord: "2.583,102.610", slug: "johor-gemasbaru" },
      { name: "Jemaluang, Johor", value: "Jemaluang, Johor", coord: "2.2579,103.9503", slug: "johor-jemaluang" },
      {
        name: "Johor Bahru, Johor", value: "Johor Bahru, Johor", coord: "1.4655,103.7578",
        slug: "johor-johorbahru"
      },
      { name: "Kahang, Johor", value: "Kahang, Johor", coord: "2.1927,103.5953", slug: "johor-kahang" },
      { name: "Kluang, Johor", value: "Kluang, Johor", coord: "2.0251,103.3318", slug: "johor-kluang" },
      { name: "Kota Tinggi, Johor", value: "Kota Tinggi, Johor", coord: "1.7381,103.8999", slug: "johor-kotatinggi" },
      { name: "Kulai, Johor", value: "Kulai, Johor", coord: "1.6626,103.6042", slug: "johor-kulai" },
      { name: "Labis, Johor", value: "Labis, Johor", coord: "2.3845,103.0254", slug: "johor-labis" },
      { name: "Mersing, Johor", value: "Mersing, Johor", coord: "2.4312,103.8405", slug: "johor-mersing" },
      { name: "Muar, Johor", value: "Muar, Johor", coord: "2.0442,102.5689", slug: "johor-muar" },
      { name: "Pagoh, Johor", value: "Pagoh, Johor", coord: "2.1481,102.7664", slug: "johor-pagoh" },
      { name: "Parit Sulong, Johor", value: "Parit Sulong, Johor", coord: "1.9681,102.8939", slug: "johor-paritsulong" },
      { name: "Pasir Gudang, Johor", value: "Pasir Gudang, Johor", coord: "1.4701,103.9076", slug: "johor-pasirgudang" },
      { name: "Pengerang, Johor", value: "Pengerang, Johor", coord: "1.3661,104.0879", slug: "johor-pengerang" },
      { name: "Pontian, Johor", value: "Pontian, Johor", coord: "1.4854,103.3882", slug: "johor-pontian" },
      { name: "Segamat, Johor", value: "Segamat, Johor", coord: "2.5148,102.8155", slug: "johor-segamat" },
      { name: "Skudai, Johor", value: "Skudai, Johor", coord: "1.5387,103.6609", slug: "johor-skudai" },
      { name: "Tangkak, Johor", value: "Tangkak, Johor", coord: "2.2651,102.5453", slug: "johor-tangkak" },
      { name: "Yong Peng, Johor", value: "Yong Peng, Johor", coord: "2.0148,103.0658", slug: "johor-yongpeng" }
    ]
  },
  {
    name: "Kedah",
    value: "Kedah",
    coord: "6.1213,100.3684",
    slug: "kedah",
    children: [
      { name: "Alor Setar, Kedah", value: "Alor Setar, Kedah", coord: "6.1265,100.3676", slug: "kedah-alorsetar" },
      { name: "Baling, Kedah", value: "Baling, Kedah", coord: "5.6776,100.9192", slug: "kedah-baling" },
      { name: "Changlun, Kedah", value: "Changlun, Kedah", coord: "6.4430,100.4261", slug: "kedah-changlun" },
      { name: "Gurun, Kedah", value: "Gurun, Kedah", coord: "5.8183,100.4738", slug: "kedah-gurun" },
      { name: "Jitra, Kedah", value: "Jitra, Kedah", coord: "6.2672,100.4218", slug: "kedah-jitra" },
      { name: "Kuala Kedah, Kedah", value: "Kuala Kedah, Kedah", coord: "6.1061,100.3079", slug: "kedah-kualakedah" },
      { name: "Kuala Nerang, Kedah", value: "Kuala Nerang, Kedah", coord: "6.2523,100.6123", slug: "kedah-kualanerang" },
      { name: "Kulim, Kedah", value: "Kulim, Kedah", coord: "5.3649,100.5616", slug: "kedah-kulim" },
      { name: "Pendang, Kedah", value: "Pendang, Kedah", coord: "5.9921,100.4768", slug: "kedah-pendang" },
      { name: "Sik, 08200 Kedah", value: "Sik, 08200 Kedah", coord: "5.8490,100.7280", slug: "kedah-sik" },
      { name: "Sungai Petani, Kedah", value: "Sungai Petani, Kedah", coord: "5.6465,100.4878", slug: "kedah-sungaipetani" },
      { name: "Yan Besar, Kedah", value: "Yan Besar, Kedah", coord: "5.7948,100.3827", slug: "kedah-yanbesar" }
    ]
  },
  {
    name: "Kelantan",
    value: "Kelantan",
    coord: "5.7624,102.2384",
    slug: "kelantan",
    children: [
      { name: "Bachok, Kelantan", value: "Bachok, Kelantan", coord: "6.0697,102.3966", slug: "kelantan-bachok" },
      { name: "Dabong, Kelantan", value: "Dabong, Kelantan", coord: "5.3868,102.0134", slug: "kelantan-dabong" },
      { name: "Gua Musang, Kelantan", value: "Gua Musang, Kelantan", coord: "4.8823,101.9682", slug: "kelantan-guamusang" },
      { name: "Jeli, Kelantan", value: "Jeli, Kelantan", coord: "5.7027,101.8430", slug: "kelantan-jeli" },
      { name: "Kota Bharu, Kelantan", value: "Kota Bharu, Kelantan", coord: "6.1331,102.2386", slug: "kelantan-kotabharu" },
      { name: "Kuala Krai, Kelantan", value: "Kuala Krai, Kelantan", coord: "5.5305,102.2019", slug: "kelantan-kualakrai" },
      { name: "Kubang Kerian, Kelantan", value: "Kubang Kerian, Kelantan", coord: "6.1667,102.2833", slug: "kelantan-kubangkerian" },
      { name: "Machang, Kelantan", value: "Machang, Kelantan", coord: "5.7693,102.2152", slug: "kelantan-machang" },
      { name: "Pasir Mas, Kelantan", value: "Pasir Mas, Kelantan", coord: "6.0493,102.1425", slug: "kelantan-pasirmas" },
      { name: "Pasir Puteh, Kelantan", value: "Pasir Puteh, Kelantan", coord: "5.8342,102.4061", slug: "kelantan-pasirputeh" },
      { name: "Rantau Panjang, Kelantan", value: "Rantau Panjang, Kelantan", coord: "6.0123,101.9778", slug: "kelantan-rantaupanjang" },
      { name: "Tanah Merah, Kelantan", value: "Tanah Merah, Kelantan", coord: "5.8091,102.1437", slug: "kelantan-tanahmerah" },
      { name: "Tumpat, Kelantan", value: "Tumpat, Kelantan", coord: "6.1977,102.1708", slug: "kelantan-tumpat" }
    ]
  },
  {
    name: "Melaka",
    value: "Melaka",
    coord: "2.2062,102.2548",
    slug: "melaka",
    children: [
      { name: "Malacca, Melaka", value: "Malacca, Melaka", coord: "2.1896,102.2501", slug: "melaka-malacca" },
      { name: "Alor Gajah, Malacca", value: "Alor Gajah, Malacca", coord: "2.3868,102.2118", slug: "melaka-alorgajah" },
      { name: "Ayer Keroh, Malacca", value: "Ayer Keroh, Malacca", coord: "2.2702,102.2824", slug: "melaka-ayerkeroh" },
      { name: "Jasin, Malacca", value: "Jasin, Malacca", coord: "2.3088,102.4295", slug: "melaka-jasin" },
      { name: "Masjid Tanah, Malacca", value: "Masjid Tanah, Malacca", coord: "2.3551,102.1124", slug: "melaka-masjidtanah" },
      { name: "Merlimau, Malacca", value: "Merlimau, Malacca", coord: "2.1497,102.4262", slug: "melaka-merlimau" },
      { name: "Sungai Udang, Malacca", value: "Sungai Udang, Malacca", coord: "2.2557,102.1535", slug: "melaka-sungaiudang" }
    ]
  },
  {
    name: "Negeri Sembilan",
    value: "Negeri Sembilan",
    coord: "2.7258,101.9424",
    slug: "negerisembilan",
    children: [
      { name: "Bahau, Negeri Sembilan", value: "Bahau, Negeri Sembilan", coord: "2.8123,102.3954", slug: "negerisembilan-bahau" },
      { name: "Gemas, Negeri Sembilan", value: "Gemas, Negeri Sembilan", coord: "2.5789,102.6177", slug: "negerisembilan-gemas" },
      { name: "Kuala Pilah, Malaysia", value: "Kuala Pilah, Malaysia", coord: "2.7381,102.2488", slug: "negerisembilan-kualapilah" },
      { name: "Linggi, Negeri Sembilan", value: "Linggi, Negeri Sembilan", coord: "2.4717,101.8304", slug: "negerisembilan-linggi" },
      { name: "Lukut, Negeri Sembilan", value: "Lukut, Negeri Sembilan", coord: "2.6049,101.8042", slug: "negerisembilan-lukut" },
      { name: "Nilai, Negeri Sembilan", value: "Nilai, Negeri Sembilan", coord: "2.8236,101.7899", slug: "negerisembilan-nilai" },
      { name: "Port Dickson, Negeri Sembilan", value: "Port Dickson, Negeri Sembilan", coord: "2.5259,101.8058", slug: "negerisembilan-portdickson" },
      { name: "Rembau, Negeri Sembilan", value: "Rembau, Negeri Sembilan", coord: "2.5838,102.0963", slug: "negerisembilan-rembau" },
      { name: "Seremban, Negeri Sembilan", value: "Seremban, Negeri Sembilan", coord: "2.7297,101.9381", slug: "negerisembilan-seremban" },
      { name: "Tampin, Negeri Sembilan", value: "Tampin, Negeri Sembilan", coord: "2.4709,102.2339", slug: "negerisembilan-tampin" }
    ]
  },
  {
    name: "Pahang",
    value: "Pahang",
    coord: "3.8126,103.3256",
    slug: "pahang",
    children: [
      { name: "Bandar Tun Abdul Razak, Pahang", value: "Bandar Tun Abdul Razak, Pahang", coord: "3.4809,102.9255", slug: "pahang-bandartunabdulrazak" },
      { name: "Bentong, Pahang", value: "Bentong, Pahang", coord: "3.5227,101.9082", slug: "pahang-bentong" },
      { name: "Brinchang, Pahang", value: "Brinchang, Pahang", coord: "4.5012,101.3822", slug: "pahang-brinchang" },
      { name: "Jerantut, Pahang", value: "Jerantut, Pahang", coord: "3.9367,102.3633", slug: "pahang-jerantut" },
      { name: "Kuala Lipis, Pahang", value: "Kuala Lipis, Pahang", coord: "4.1842,102.0468", slug: "pahang-kualalipis" },
      { name: "Kuala Rompin, Pahang", value: "Kuala Rompin, Pahang", coord: "2.7921,103.5026", slug: "pahang-kualarompin" },
      { name: "Kuantan, Pahang", value: "Kuantan, Pahang", coord: "3.8077,103.3260", slug: "pahang-kuantan" },
      { name: "Maran, Pahang", value: "Maran, Pahang", coord: "3.5877,102.7514", slug: "pahang-maran" },
      { name: "Mentakab, Pahang", value: "Mentakab, Pahang", coord: "3.4862,102.3491", slug: "pahang-mentakab" },
      { name: "Muadzam Shah, Pahang", value: "Muadzam Shah, Pahang", coord: "3.0660,103.0926", slug: "pahang-muadzamshah" },
      { name: "Pekan, Pahang", value: "Pekan, Pahang", coord: "3.4921,103.3961", slug: "pahang-pekan" },
      { name: "Raub, Pahang", value: "Raub, Pahang", coord: "3.7930,101.8520", slug: "pahang-raub" },
      { name: "Sri Jaya, Pahang", value: "Sri Jaya, Pahang", coord: "3.6859,103.2162", slug: "pahang-srijaya" },
      { name: "Tanah Rata, Pahang", value: "Tanah Rata, Pahang", coord: "4.4637,101.3769", slug: "pahang-tanahrata" },
      { name: "Temerloh, Pahang", value: "Temerloh, Pahang", coord: "3.4506,102.4176", slug: "pahang-temerloh" },
      { name: "Triang, Pahang", value: "Triang, Pahang", coord: "3.1761,102.4993", slug: "pahang-triang" }
    ]
  },
  {
    name: "Penang",
    value: "Penang",
    coord: "5.4141,100.3292",
    slug: "penang",
    children: [
      { name: "Balik Pulau,Penang", value: "Balik Pulau,Penang", coord: "5.3590,100.2350", slug: "penang-balikpulau" },
      { name: "Batu Kawan, 14100", value: "Batu Kawan, 14100", coord: "5.2792,100.4197", slug: "penang-batukawan" },
      { name: "Bayan Lepas, Penang", value: "Bayan Lepas, Penang", coord: "5.3169,100.2905", slug: "penang-bayanlepas" },
      { name: "Bukit Mertajam, Penang", value: "Bukit Mertajam, Penang", coord: "5.3630,100.4678", slug: "penang-bukitmertajam" },
      { name: "Butterworth, Penang, Malaysia", value: "Butterworth, Penang, Malaysia", coord: "5.3999,100.3638", slug: "penang-butterworth" },
      { name: "George Town, Penang, Malaysia", value: "George Town, Penang, Malaysia", coord: "5.4145,100.3292", slug: "penang-georgetown" },
      { name: "Kepala Batas, Penang", value: "Kepala Batas, Penang", coord: "5.5157,100.4380", slug: "penang-kepalabatas" },
      { name: "Nibong Tebal, Penang", value: "Nibong Tebal, Penang", coord: "5.1696,100.4784", slug: "penang-nibongtebal" },
      { name: "Tasek Gelugor", value: "Tasek Gelugor", coord: "5.4822,100.4989", slug: "penang-tasekgelugor" }
    ]
  },
  {
    name: "Perak",
    value: "Perak",
    coord: "4.5921,101.0901",
    slug: "perak",
    children: [
      { name: "Batu Gajah, Perak", value: "Batu Gajah, Perak", coord: "4.4671,101.0413", slug: "perak-batugajah" },
      { name: "Bidor, Perak, Malaysia", value: "Bidor, Perak, Malaysia", coord: "4.1077,101.2868", slug: "perak-bidor" },
      { name: "Gerik, Perak, Malaysia", value: "Gerik, Perak, Malaysia", coord: "5.4292,101.1279", slug: "perak-gerik" },
      { name: "Ipoh, Perak", value: "Ipoh, Perak", coord: "4.5975,101.0901", slug: "perak-ipoh" },
      { name: "Kampar, Perak", value: "Kampar, Perak", coord: "4.3105,101.1548", slug: "perak-kampar" },
      { name: "Kuala Kangsar, Malaysia", value: "Kuala Kangsar, Malaysia", coord: "4.7667,100.9333", slug: "perak-kualakangsar" },
      { name: "Lumut, Perak", value: "Lumut, Perak", coord: "4.2394,100.6310", slug: "perak-lumut" },
      { name: "Parit Buntar, Perak", value: "Parit Buntar, Perak", coord: "5.1274,100.4932", slug: "perak-paritbuntar" },
      { name: "Parit, Perak", value: "Parit, Perak", coord: "4.4513,100.9022", slug: "perak-parit" },
      { name: "Sitiawan, Perak", value: "Sitiawan, Perak", coord: "4.2173,100.6980", slug: "perak-sitiawan" },
      { name: "Taiping, Perak", value: "Taiping, Perak", coord: "4.8528,100.7392", slug: "perak-taiping" },
      { name: "Tanjong Malim, Perak", value: "Tanjong Malim, Perak", coord: "3.6799,101.5225", slug: "perak-tanjongmalim" },
      { name: "Tapah, Perak", value: "Tapah, Perak", coord: "4.1977,101.2579", slug: "perak-tapah" },
      { name: "Teluk Intan, Perak", value: "Teluk Intan, Perak", coord: "4.0226,101.0213", slug: "perak-telukintan" }
    ]
  },
  {
    name: "Perlis",
    value: "Perlis",
    coord: "6.4449,100.2048",
    slug: "perlis",
    children: [
      { name: "Arau, Perlis", value: "Arau, Perlis", coord: "6.4297,100.2690", slug: "perlis-arau" },
      { name: "Kangar, Perlis, Malaysia", value: "Kangar, Perlis, Malaysia", coord: "6.4414,100.1986", slug: "perlis-kangar" },
      { name: "Kuala Perlis, Perlis", value: "Kuala Perlis, Perlis", coord: "6.3986,100.1329", slug: "perlis-kualaperlis" },
      { name: "Padang Besar, Perlis", value: "Padang Besar, Perlis", coord: "6.6629,100.3208", slug: "perlis-padangbesar" }
    ]
  },
  {
    name: "Terengganu",
    value: "Terengganu",
    coord: "5.3302,103.1408",
    slug: "terengganu",
    children: [
      { name: "Bandar Permaisuri, Terengganu", value: "Bandar Permaisuri, Terengganu", coord: "5.5682,102.7657", slug: "terengganu-bandarpermaisuri" },
      { name: "Jerteh, Terengganu", value: "Jerteh, Terengganu", coord: "5.7403,102.4915", slug: "terengganu-jerteh" },
      { name: "Chukai, Terengganu", value: "Chukai, Terengganu", coord: "4.2334,103.4487", slug: "terengganu-chukai" },
      { name: "Dungun, Terengganu", value: "Dungun, Terengganu", coord: "4.7516,103.4192", slug: "terengganu-dungun" },
      { name: "Bukit Payong, Terengganu", value: "Bukit Payong, Terengganu", coord: "5.4244,103.0852", slug: "terengganu-bukitpayong" },
      { name: "Bandar Bukit Besi, Terengganu", value: "Bandar Bukit Besi, Terengganu", coord: "4.7017,103.2332", slug: "terengganu-bandarbukitbesi" },
      { name: "Kuala Berang, Terengganu", value: "Kuala Berang, Terengganu", coord: "5.0787,103.0126", slug: "terengganu-kualaberang" },
      { name: "Kuala Besut, Terengganu", value: "Kuala Besut, Terengganu", coord: "5.8323,102.5557", slug: "terengganu-kualabesut" },
      { name: "Kerteh, Terengganu", value: "Kerteh, Terengganu", coord: "4.5140,103.4569", slug: "terengganu-kerteh" },
      { name: "Kuala Terengganu, Terengganu", value: "Kuala Terengganu, Terengganu", coord: "5.3302,103.1408", slug: "terengganu-kualaterengganu" },
      { name: "Marang, Terengganu", value: "Marang, Terengganu", coord: "5.2063,103.2187", slug: "terengganu-marang" }
    ]
  },
  {
    name: "Labuan",
    value: "Labuan",
    coord: "5.2831,115.2308",
    slug: "labuan",
    children: [
      { name: "Labuan, Malaysia", value: "Labuan, Malaysia", coord: "5.2831,115.2308", slug: "labuan-labuan" }
    ]
  },
  {
    name: "Sabah",
    value: "Sabah",
    coord: "5.9804,116.0735",
    slug: "sabah",
    children: [
      { name: "Beaufort, Sabah", value: "Beaufort, Sabah", coord: "5.3473,115.7455", slug: "sabah-beaufort" },
      { name: "Keningau, Sabah", value: "Keningau, Sabah", coord: "5.3378,116.1602", slug: "sabah-keningau" },
      { name: "Kimanis, Sabah", value: "Kimanis, Sabah", coord: "5.6372,115.9277", slug: "sabah-kimanis" },
      { name: "Kota Belud, Sabah", value: "Kota Belud, Sabah", coord: "6.3512,116.4306", slug: "sabah-kotabelud" },
      { name: "Kota Kinabalu, Sabah", value: "Kota Kinabalu, Sabah", coord: "5.9804,116.0735", slug: "sabah-kotakinabalu" },
      { name: "Kudat, Sabah", value: "Kudat, Sabah", coord: "6.8841,116.8468", slug: "sabah-kudat" },
      { name: "Lahad Datu, Sabah", value: "Lahad Datu, Sabah", coord: "5.0269,118.3269", slug: "sabah-lahaddatu" },
      { name: "Papar, Sabah", value: "Papar, Sabah", coord: "5.7329,115.9297", slug: "sabah-papar" },
      { name: "Ranau, Sabah", value: "Ranau, Sabah", coord: "5.9539,116.6645", slug: "sabah-ranau" },
      { name: "Sandakan, Sabah", value: "Sandakan, Sabah", coord: "5.8402,118.1179", slug: "sabah-sandakan" },
      { name: "Semporna, Sabah", value: "Semporna, Sabah", coord: "4.4818,118.6102", slug: "sabah-semporna" },
      { name: "Sipitang, Sabah", value: "Sipitang, Sabah", coord: "5.0994,115.5626", slug: "sabah-sipitang" },
      { name: "Tawau 91007, Sabah", value: "Tawau 91007, Sabah", coord: "4.2448,117.8911", slug: "sabah-tawau" },
      { name: "Tenom, Sabah", value: "Tenom, Sabah", coord: "5.1241,115.9429", slug: "sabah-tenom" },
      { name: "Tuaran, Sabah", value: "Tuaran, Sabah", coord: "6.1791,116.2346", slug: "sabah-tuaran" }
    ]
  },
  {
    name: "Sarawak",
    value: "Sarawak",
    coord: "1.5533,110.3593",
    slug: "sarawak",
    children: [
      { name: "Bau 94000, Sarawak", value: "Bau 94000, Sarawak", coord: "1.4216,110.1541", slug: "sarawak-bau" },
      { name: "Betong, Sarawak", value: "Betong, Sarawak", coord: "1.4216,111.5166", slug: "sarawak-betong" },
      { name: "Bintulu, Sarawak", value: "Bintulu, Sarawak", coord: "3.1712,113.0355", slug: "sarawak-bintulu" },
      { name: "Kanowit, Sarawak", value: "Kanowit, Sarawak", coord: "2.1024,112.4344", slug: "sarawak-kanowit" },
      { name: "Kapit, Sarawak", value: "Kapit, Sarawak", coord: "2.0138,112.9326", slug: "sarawak-kapit" },
      { name: "Kota Samarahan, Sarawak", value: "Kota Samarahan, Sarawak", coord: "1.4612,110.4900", slug: "sarawak-kotasamarahan" },
      { name: "Kuching, Sarawak", value: "Kuching, Sarawak", coord: "1.5533,110.3593", slug: "sarawak-kuching" },
      { name: "Lawas, Sarawak", value: "Lawas, Sarawak", coord: "4.8563,115.4070", slug: "sarawak-lawas" },
      { name: "Limbang, Sarawak", value: "Limbang, Sarawak", coord: "4.7553,115.0078", slug: "sarawak-limbang" },
      { name: "Lundu, Sarawak", value: "Lundu, Sarawak", coord: "1.6731,109.8528", slug: "sarawak-lundu" },
      { name: "Miri, Sarawak", value: "Miri, Sarawak", coord: "4.3987,113.9914", slug: "sarawak-miri" },
      { name: "Mukah, Sarawak", value: "Mukah, Sarawak", coord: "2.9023,112.0912", slug: "sarawak-mukah" },
      { name: "Niah, Sarawak", value: "Niah, Sarawak", coord: "3.7806,113.7794", slug: "sarawak-niah" },
      { name: "Saratok, Sarawak", value: "Saratok, Sarawak", coord: "1.7389,111.3520", slug: "sarawak-saratok" },
      { name: "Sarikei, Sarawak", value: "Sarikei, Sarawak", coord: "2.1289,111.5213", slug: "sarawak-sarikei" },
      { name: "Sematan, Sarawak", value: "Sematan, Sarawak", coord: "1.8086,109.7689", slug: "sarawak-sematan" },
      { name: "Serian, Sarawak", value: "Serian, Sarawak", coord: "1.1711,110.5663", slug: "sarawak-serian" },
      { name: "Sibu, Sarawak", value: "Sibu, Sarawak", coord: "2.3164,111.8301", slug: "sarawak-sibu" },
      { name: "Simanggang (Sri Aman), Sarawak", value: "Simanggang (Sri Aman), Sarawak", coord: "1.2381,111.4618", slug: "sarawak-sriaman" }
    ]
  },
];

export default statechildren;
